import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as _ from 'lodash';
import { I18n } from 'react-redux-i18n-lite';

import ClassroomArchiveCard from './ClassroomArchiveCard';

import * as messageAlert from '../../../../actions/messageAlertAction';
import * as classroomActions from '../../../../actions/classroom/classroomActions';
import { getUserRole } from '../../../../services/jwt/jwtService';
import { ROLE } from '../../../../const';
import SadMonster from '../../../common/EmptyListPlaceholder/SadMonster';
import ClassroomCardPlaceholder from '../../../classroom/ClassroomCardPlaceholder';

class ClassroomArchiveContainer extends React.Component {
  componentDidMount = () => {
    if (getUserRole(this.props) === ROLE.INSTRUCTOR) {
      const { classroomActions } = this.props;
      classroomActions.getArchivedClassroomData();
    }
  };

  groupBySchoolYear = () => {
    const { archivedClassrooms, startClassMonth } = this.props;
    return _.groupBy(archivedClassrooms, classroom => {
      let archivedDate = new Date(classroom.archivedAt);
      let year = archivedDate.getFullYear();

      if (archivedDate.getMonth() + 1 < startClassMonth) {
        year--;
      }

      return `${year}/${year + 1}`;
    });
  };

  recoverClassroom = classroom => {
    const { classroomActions } = this.props;
    classroomActions.recoverClassroom(classroom);
  };

  getOptions = (classroom, role) => {
    // Same shape as the other DropdownOptions items ({ key, text, onClick, icon })
    const recoverOption = {
      key: 'recover',
      text: I18n.t('common.option.recover'),
      onClick: () => this.recoverClassroom(classroom),
      icon: 'custom-icons-backward-arrow'
    };

    const options = {
      [ROLE.INSTRUCTOR]: [recoverOption],
      [ROLE.COINSTRUCTOR]: [],
      [ROLE.STUDENT]: []
    };

    return options[role];
  };

  render() {
    const classroomsBySchoolYear = this.groupBySchoolYear();
    const years = Object.keys(classroomsBySchoolYear);
    const { fetchingClassrooms } = this.props;

    if (_.isEmpty(classroomsBySchoolYear)) {
      return (
        <div style={{ height: 'calc(100% - 56px)', display: 'flex', justifyContent: 'center' }}>
          <SadMonster msgKey="classroom.noClassroomsFound" />
        </div>
      );
    }

    return (
      <div className="classroom-archive-container">
        {fetchingClassrooms ? (
          <ClassroomCardPlaceholder key="CardsPlaceholder" id="CardsPlaceholder" />
        ) : (
          years.map((year, index) => (
            <div key={index}>
              <div className="yearClasifier">{year}</div>
              <div className="cardRow">
                {classroomsBySchoolYear[year].map((classroom, index) => (
                  <div className="classroom-active-card" key={index}>
                    <ClassroomArchiveCard
                      id={classroom.id}
                      classCode={classroom.classCode}
                      name={classroom.name}
                      image={classroom.picture}
                      archiveDate={new Date(classroom.archivedAt)}
                      optionItems={this.getOptions(classroom, classroom.role)}
                    />
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    );
  }
}

ClassroomArchiveContainer.propTypes = {
  archivedClassrooms: PropTypes.array,
  classroomActions: PropTypes.any,
  messageAlert: PropTypes.any
};

function mapStateToProps(state) {
  return {
    account: state.account,
    archivedClassrooms: state.classrooms.archivedClassrooms,
    fetchingClassrooms: state.classrooms.fetching,
    i18n: state.i18n,
    startClassMonth: state.account.configuration.startClassMonth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomActions: bindActionCreators(classroomActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassroomArchiveContainer);
